import { useEffect, useState } from "react";
import { AlertTriangle, X } from "lucide-react";

export default function BrowserWarning() {
  const [hidden, setHidden] = useState(false);
  const [unsupported, setUnsupported] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const ua = navigator.userAgent || "";
    const isEdge = /Edg\//i.test(ua);
    const isChrome = /Chrome\//i.test(ua) && !/OPR\//i.test(ua);
    const hasSR =
      "SpeechRecognition" in window || "webkitSpeechRecognition" in window;
    setUnsupported(!hasSR && !(isChrome || isEdge));
  }, []);

  if (!unsupported || hidden) return null;

  return (
    <div
      data-testid="browser-warning"
      className="bg-[#FEF3C7] border-b border-[#FDE68A]"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-2.5 flex items-start sm:items-center justify-between gap-3">
        <div className="flex items-start sm:items-center gap-2.5 min-w-0">
          <AlertTriangle className="w-4 h-4 text-[#B45309] flex-shrink-0 mt-0.5 sm:mt-0" />
          <p className="font-figtree text-xs sm:text-sm text-[#78350F] leading-snug">
            Your browser doesn't support live transcription. You can still record
            sessions here and use <strong>Transcribe with AI</strong> after each
            recording. For the smoothest experience use <strong>Chrome</strong>
            {" "}or <strong>Edge</strong>.
          </p>
        </div>
        <button
          aria-label="Dismiss"
          data-testid="browser-warning-dismiss"
          onClick={() => setHidden(true)}
          className="flex-shrink-0 inline-flex items-center justify-center w-6 h-6 rounded-full hover:bg-[#FDE68A] text-[#B45309] transition-colors"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
